import { render, staticRenderFns } from "./product-bucket.vue?vue&type=template&id=38f8baa2&scoped=true&"
import script from "./product-bucket.vue?vue&type=script&lang=js&"
export * from "./product-bucket.vue?vue&type=script&lang=js&"
import style0 from "./product-bucket.vue?vue&type=style&index=0&id=38f8baa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f8baa2",
  null
  
)

export default component.exports